import { styled } from '@compiled/react';

import { B50 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

type StyledSelectorType = { 'data-styled-selector'?: string };
type TemplateCardWrapperProps = {
	isActive?: boolean;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Title = styled.div({
	minHeight: '19px',
	maxHeight: '38px',
	display: '-webkit-box',
	WebkitLineClamp: '2',
	WebkitBoxOrient: 'vertical',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Description = styled.div({
	marginTop: token('space.050', '4px'),
	minHeight: '16px',
	maxHeight: '64px',
	display: '-webkit-box',
	WebkitLineClamp: '4',
	WebkitBoxOrient: 'vertical',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
});

const itemContainerSelector = 'template-card.ItemContainer';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ItemContainer = styled.div<StyledSelectorType>({
	position: 'absolute',
	right: token('space.025', '2px'),
	top: token('space.025', '2px'),
	float: 'right',
});
ItemContainer.defaultProps = {
	'data-styled-selector': itemContainerSelector,
};

const starContainerSelector = 'template-card.StarContainer';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StarContainer = styled.button<
	{
		isVisible?: boolean;
	} & StyledSelectorType
>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	opacity: (props) => (props.isVisible ? 1 : 0),
	border: '0 none',
	background: 'transparent',
	padding: 0,
	cursor: 'pointer',
	float: 'right',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	svg: {
		borderRadius: '50%',
		willChange: 'transform',
	},
	'&:focus': {
		opacity: 1,
	},
	'&:disabled': {
		cursor: 'inherit',
	},
});
StarContainer.defaultProps = {
	'data-styled-selector': starContainerSelector,
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TemplateCardWrapper = styled.button<TemplateCardWrapperProps>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
	marginBottom: `${token('space.200', '16px')} !important`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
	padding: `${token('space.100', '8px')} !important`,
	boxSizing: 'border-box',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	background: (props) =>
		props.isActive ? `${token('color.background.selected', B50)} !important` : 'inherit',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	[`&:focus + [data-styled-selector="${itemContainerSelector}"]`]: {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
		[`[data-styled-selector="${starContainerSelector}"]`]: {
			opacity: 1,
		},
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const DescriptionContainer = styled.div({
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	span: {
		marginTop: token('space.050', '4px'),
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TitleContainer = styled.div({
	display: 'flex',
	alignItems: 'center',
	gap: token('space.075', '6px'),
	marginTop: token('space.negative.050', '-4px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AvatarContainer = styled.div({
	position: 'relative',
	'&:hover': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
		[`[data-styled-selector="${starContainerSelector}"]`]: {
			opacity: 1,
		},
	},
});
